import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import TooltipDisclaimer from '@app/components/common/Availability/TooltipDisclaimer';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import queryString from 'query-string';
import { ORDER_TYPES } from '@app/constants/commonConstants';

const ItemOrderTableAvalabilityLabel = () => {
  const [t] = useTranslation();
  const searchParams = useLocation().search;
  const isQuantityMergeEnabled = useSelector(
    s => s?.common?.isQuantityMergeEnabled
  );

  const { orderType } = queryString.parse(searchParams);

  return (
    <div>
      <div className="d-flex align-items-end">
        <span className="text-univers--bold text-sm color-dark-gray m-0">
          {orderType === ORDER_TYPES.OFFLINE_ORDER
            ? t('OFFLINE_ORD_BO_QTY')
            : t('AVAILABILITY')}
          {!isQuantityMergeEnabled && <sup data-testid="dagger">&dagger;</sup>}
        </span>
        <TooltipDisclaimer />
      </div>
    </div>
  );
};

ItemOrderTableAvalabilityLabel.propTypes = {
  isQuantityMergeEnabled: PropTypes.bool
};

export default ItemOrderTableAvalabilityLabel;
